<button
  *ngrxLet="isDisabled$ as disabled"
  mat-raised-button
  class="image !h-full"
  matTooltip="Romexis integration requires patient date of birth"
  [matTooltipDisabled]="!disabled"
  [matMenuTriggerFor]="menu"
  [disabled]="disabled"
>
  <div class="flex items-center gap-1">
    Romexis
    <mat-icon>arrow_drop_down</mat-icon>
  </div>
</button>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="openRomexisSettings()">
    <mat-icon class="icon-sm opacity-80">settings_application</mat-icon>
    <span>Romexis Bridge Settings</span>
  </button>

  <mat-divider />

  @for (mode of captureModes; track mode.mode) {
    <button mat-menu-item (click)="openRomexis(mode.mode)">
      {{ mode.label }}
    </button>
  }
</mat-menu>
